const Theme = {
  body_background_color: 'white',

  logo_image_url: 'lecircuitdupaysan.svg',
  logo_height: 100,

  token_url: 'lecircuitdupaysan.png',
  number_hidden: true,

  button_color: '#e68a00',
  button_font: `'Montserrat', sans-serif`,
  button_text_lineheight: 25,
  button_text_size: 15,
  button_text_weight: 700,
  button_text_uppercase: true,

  button_half_border_color: '#e68a00',

  text_font: `'Montserrat', sans-serif`,
  text_color: '#2b3243',
  text_size: 15,
  text_lineheight: 21,

  title_font: `'PTSerif', serif`,
  title_color: '#2b3243',
  title_size: 28,
  title_lineheight: 33,
  title_letter_spacing: 3,
  title_weight: 300,

  subtitle_font: `'Montserrat', sans-serif`,
  subtitle_color: '#2b3243',
  subtitle_size: 15,
  subtitle_lineheight: 25,
  subtitle_weight: 700,
  subtitle_uppercase: true,
}

export default Theme
